import { render, staticRenderFns } from "./DisplaySpotProcesses.vue?vue&type=template&id=072002c8&scoped=true&"
import script from "./DisplaySpotProcesses.vue?vue&type=script&lang=js&"
export * from "./DisplaySpotProcesses.vue?vue&type=script&lang=js&"
import style0 from "./DisplaySpotProcesses.vue?vue&type=style&index=0&id=072002c8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072002c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VDataTable,VIcon,VSpacer,VTextField,VToolbar,VToolbarTitle,VTooltip})
